<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
strong {
  font-weight: 700;
}
a {
  color: #174b93;
}
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Roboto:wght@400;500;700&display=swap');
@font-face {
  font-family: 'SFProDisplay';
  src: url('~@/components/assets/fonts/SFProDisplay-Light/SFProDisplay-Light.eot');
  src: url('~@/components/assets/fonts/SFProDisplay-Light/SFProDisplay-Light.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/SFProDisplay-Light/SFProDisplay-Light.woff') format('woff'),
    url('~@/components/assets/fonts/SFProDisplay-Light/SFProDisplay-Light.ttf') format('truetype');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: 'SFProDisplay';
  src: url('~@/components/assets/fonts/SFProDisplay-Regular/SFProDisplay-Regular.eot');
  src: url('~@/components/assets/fonts/SFProDisplay-Regular/SFProDisplay-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/SFProDisplay-Regular/SFProDisplay-Regular.woff') format('woff'),
    url('~@/components/assets/fonts/SFProDisplay-Regular/SFProDisplay-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: 'SFProDisplay';
  src: url('~@/components/assets/fonts/SFProDisplay-Bold/SFProDisplay-Bold.eot');
  src: url('~@/components/assets/fonts/SFProDisplay-Bold/SFProDisplay-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/SFProDisplay-Bold/SFProDisplay-Bold.woff') format('woff'),
    url('~@/components/assets/fonts/SFProDisplay-Bold/SFProDisplay-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: 'SFProDisplay';
  src: url('~@/components/assets/fonts/SFProDisplay-Black/SFProDisplay-Black.eot');
  src: url('~@/components/assets/fonts/SFProDisplay-Black/SFProDisplay-Black.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/SFProDisplay-Black/SFProDisplay-Black.woff') format('woff'),
    url('~@/components/assets/fonts/SFProDisplay-Black/SFProDisplay-Black.ttf') format('truetype');
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: 'ALSRubl';
  src: url('~@/components/assets/fonts/ALSRubl/ALSRubl.eot');
  src: url('~@/components/assets/fonts/ALSRubl/ALSRubl.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/ALSRubl/ALSRubl.woff') format('woff'),
    url('~@/components/assets/fonts/ALSRubl/ALSRubl.ttf') format('truetype');
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: url('~@/components/assets/fonts/Roboto-Regular/Roboto-Regular.eot');
  src: url('~@/components/assets/fonts/Roboto-Regular/Roboto-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/Roboto-Regular/Roboto-Regular.woff') format('woff'),
    url('~@/components/assets/fonts/Roboto-Regular/Roboto-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: url('~@/components/assets/fonts/Roboto-Medium/Roboto-Medium.eot');
  src: url('~@/components/assets/fonts/Roboto-Medium/Roboto-Medium.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/Roboto-Medium/Roboto-Medium.woff') format('woff'),
    url('~@/components/assets/fonts/Roboto-Medium/Roboto-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'Roboto';
  src: url('~@/components/assets/fonts/Roboto-Bold/Roboto-Bold.eot');
  src: url('~@/components/assets/fonts/Roboto-Bold/Roboto-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/Roboto-Bold/Roboto-Bold.woff') format('woff'),
    url('~@/components/assets/fonts/Roboto-Bold/Roboto-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: 'Open Sans';
  src: url('~@/components/assets/fonts/OpenSans-Regular/OpenSans-Regular.eot');
  src: url('~@/components/assets/fonts/OpenSans-Regular/OpenSans-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/OpenSans-Regular/OpenSans-Regular.woff') format('woff'),
    url('~@/components/assets/fonts/OpenSans-Regular/OpenSans-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: 'Open Sans';
  src: url('~@/components/assets/fonts/OpenSans-SemiBold/OpenSans-SemiBold.eot');
  src: url('~@/components/assets/fonts/OpenSans-SemiBold/OpenSans-SemiBold.eot?#iefix') format('embedded-opentype'),
    url('~@/components/assets/fonts/OpenSans-SemiBold/OpenSans-SemiBold.woff') format('woff'),
    url('~@/components/assets/fonts/OpenSans-SemiBold/OpenSans-SemiBold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
}
body {
  margin: 0;
  background: rgba(243, 245, 246, .6);
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
}
* {
  box-sizing: border-box;
  outline: none !important;
}
.rub {
  font-family: 'ALSRubl';
}
#app {
  overflow: hidden;
}
.modal-form .modal-footer {
  display: none;
}
.modal-form .modal-header {
  border: 0;
  padding: 0;
}
.modal-form .close {
  top: 24px;
  right: 28px;
  position: absolute;
  font-size: 1.8rem;
  font-weight: 400;
  z-index: 50;
}
.modal-form .modal-body {
  padding: 32px;
}
.modal-form__header {
  font: 700 16px/1.5em 'Roboto', sans-serif;
  margin-bottom: 32px;
}
/* .modal-backdrop {
  opacity: .1;
} */
.modal-content {
  border-radius: 12px;
  box-shadow: 0 12px 24px 0 rgba(45, 73, 88, 0.15);
  border: solid 1px #ebebeb;
  background-color: #ffffff;
}
.ho-message__error {
  padding: 24px 24px 24px 60px;
  border-radius: 16px;
  border: solid 1px #d43836;
  background-color: rgba(212, 56, 54, 0.1);
  font: 700 14px/1.43em 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #262626;
  position: relative;
}
.ho-message__error:before {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 24px;
  height: 22px;
  background: url(assets/img/ico-error.svg) 0 0 no-repeat;
  background-size: contain;
}
.ho {
  border-top: 8px solid #174b93;
  display: table;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}
.ho:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  top: 270px;
  bottom: 0;
  background: #fff;
}
.ho.nobg:before {
  display: none;
}
.ho.nobg .ho-body__body {
  background: none;
}
.ho.nobg .ho-body__body {
  border: 0;
  padding-top: 0;
}
.ho.nobg .ho-body__head {
  padding-bottom: 0;
}
.ho-body {
  display: table-cell;
  vertical-align: top;
  position: relative;
  box-sizing: border-box;
  padding: 64px 0 0 0;
  position: relative;
}
.ho-body__empty {
  font: 300 24px/1.1em 'Roboto', sans-serif;
  letter-spacing: 1px;
  text-align: center;
  color: rgba(38, 38, 38, .3);
  margin-top: 22vh;
}
.ho-body__empty:before {
  content: ' ';
  display: block;
  margin: 0 auto 32px;
  width: 65px;
  height: 48px;
  background: url(assets/img/ico-empty.svg) 0 0 no-repeat;
}
.ho-body__booking {
  padding-left: 49px;
  margin-bottom: 48px;
}
.ho-body__grid {
  max-width: 960px;
  margin: 0;
}
.ho-box {
  background: #fff;
  border-radius: 8px;
  padding: 32px;
  margin: 0 1px 32px;
  box-shadow: 0 5px 10px -5px rgba(45, 73, 88, 0.15);
  border: solid 1px #ebebeb;
  background-color: #ffffff;
  position: relative;
}
.ho-box__header {
  margin: 0 0 24px;
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.3px;
  color: #262626;
}
.ho-box__header span {
  display: block;
  color: #262626;
  font-weight: 400;
  opacity: 0.5;
  font-size: 16px;
  line-height: 1.5;
  margin-top: 4px;
}
.ho-box__tooltip {
  position: absolute;
  top: 24px;
  right: 28px;
}
.ho-box__btn {
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  padding: 0;
  background: none;
  outline: none !important;
}
.ho-box__btn:before {
  content: ' ';
  position: absolute;
  top: -10px;
  left: -4px;
  right: -4px;
  bottom: -10px;
  outline: none !important;
}
.ho-box__tooltip-open {
  position: absolute;
  top: 32px;
  right: -13px;
  border-radius: 16px;
  box-shadow: 0 12px 24px 0 rgba(45, 73, 88, 0.15);
  border: solid 1px #ebebeb;
  background-color: #ffffff;
  padding: 0 32px;
  z-index: 50;
}
.ho-box__tooltip-open li {
  margin: 30px 0;
}
.ho-box__tooltip-open li a {
  text-decoration: none;
  letter-spacing: 0.2px;
  color: #262626;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.ho-box__body {
  display: table;
  width: 100%;
}
.ho-box__body-column {
  display: table-cell;
  vertical-align: top;
}
.ho-box__body-column span {
  display: block;
  margin-bottom: 4px;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-box__body-column strong {
  display: block;
  font: 900 32px/1.25 'SFProDisplay';
  letter-spacing: 0.46px;
  color: #262626;
}
.ho-box__name {
  font-size: 16px;
  margin-bottom: 8px;
}
.ho-box__body-line {
  margin-bottom: 2px;
}
.ho-box__body-line strong {
  font: 900 20px/1.15 'SFProDisplay';
  letter-spacing: 0.29px;
}
.ho-box__body-line span {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-box__body-row {
  display: table;
  width: 100%;
  margin-bottom: 4px;
}
.ho-box__body-row span {
  display: table-cell;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-box__body-row strong {
  display: table-cell;
  text-align: right;
  font: 900 20px/24px 'SFProDisplay';
  letter-spacing: 0.29px;
}
.lnk {
  font-size: 14px;
  color: #000000;
  opacity: 1;
  text-shadow: none;
  margin: 0;
  padding: 0;
  font-weight: 700;
  text-decoration: none;
}
.lnk:hover {
  color: #000000;
  text-decoration: none;
  opacity: .7;
}
.lnk:active {
  opacity: .3;
}
.lnk span {
  font-size: 21px;
  position: relative;
  top: 2px;
  margin-right: 5px;
}
.btn {
  height: 48px;
  border-radius: 8px;
  box-shadow: 0 5px 10px -5px rgba(45, 73, 88, 0.15) !important;
  background: #fff !important;
  border: solid 1px #ebebeb !important;
  display: inline-block;
  vertical-align: top;
  padding: 0 24px 0 16px;
  font: 700 14px/46px 'SFProDisplay';
  color: #000000 !important;
  text-decoration: none;
}
.btn:hover {
  background-color: #f8f8f8 !important;
  color: #000000 !important;
}
.btn[disabled] {
  background-color: #ffffff !important;
  color: rgba(45, 45, 45, .5) !important;
}
.btn img {
  margin-right: 10px;
  vertical-align: middle;
}
.btn-big {
  height: 56px;
  line-height: 56px;
  padding: 0 32px;
  font-size: 16px;
}
.btn-min {
  height: 36px;
  line-height: 36px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: center;
}
.btn--blue {
  background: #174b93 !important;
  color: #fff !important;
}
.btn--blue:hover {
  background: #0f4083 !important;
  color: #fff !important;
}
.btn--blue[disabled] {
  background: rgba(45, 73, 88, 0.15) !important;
  cursor: default;
}
.btn--mini {
  height: 44px;
  line-height: 44px;
  border-radius: 16px;
  background: #f6f6f6 !important;
  color: #174b93 !important;
  border: 0 !important;
  text-decoration: none !important;
}
.btn--mini:hover {
  background-color: #f8f8f8 !important;
  color: #000000 !important;
}
.ho-body__head {
  padding: 0 20px 35px 64px;
  max-width: 1012px;
  position: relative;
  z-index: 10;
}
.ho-body__head--bg:before {
  content: ' ';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  background: #f3f5f6;
}
.ho-body__head--setting {
  padding-bottom: 0;
}
.ho-body__head__lnk-setting {
  float: right;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.43;
  letter-spacing: 0.2px;
}
.ho-body__head__lnk-setting a {
  color: #174b93;
}
.ho-body__head-btn {
  float: right;
}
.ho-body__head-btn .lnk {
  position: relative;
  top: 5px;
}
.lnk--gray {
  color: #5e6777;
}
.lnk--gray:hover {
  color: #333 !important;
}
.ho-body__head-header {
  font: 900 32px/1.25 'SFProDisplay';
  letter-spacing: 0.46px;
  color: #262626;
  margin-bottom: 50px;
  text-transform: uppercase;
}
.ho-body__filter {
  display: inline-block;
  vertical-align: top;
  margin: 0 32px 0 0;
  padding: 0;
  position: relative;
}
.ho-body__filter.disable {
  opacity: 0.7;
}
.ho-body__filter.disable:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
}
.ho-body__filter.disable .ho-body__filter-arrow {
  opacity: 0;
}
.ho-body__filter-wr .ho-body__filter:last-child {
  margin: 0;
}
.ho-body__filter-wr .ho-body__head-search {
  display: inline-block;
  vertical-align: top;
  margin-top: -10px;
  margin-bottom: 12px;
}
.ho-body__filter-name {
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  padding-right: 26px;
  position: relative;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
.ho-body__filter-name:hover {
  opacity: .7;
}
.ho-body__filter-name span {
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ho-body__filter-arrow {
  position: absolute;
  top: -2px;
  right: 0;
}
.active .ho-body__filter-arrow {
  transform: rotate(180deg);
}
.ho-body__filter-popup {
  position: absolute;
  top: 37px;
  left: -5px;
  background: #fff;
  width: 304px;
  padding: 24px;
  border-radius: 16px;
  border: solid 1px #ebebeb;
}
.ho-body__filter-popup--date {
  width: auto;
}
.ho-body__filter-popup ul {
  padding: 0;
}
.ho-body__filter-popup ul li {
  display: block;
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: rgba(38, 38, 38, 0.55);
  cursor: pointer;
}
.ho-body__filter-popup ul li:hover {
  color: rgba(38, 38, 38, 0.8);
}
.ho-body__filter-popup ul li.active {
  color: #262626;
  cursor: default;
}
.ho-body__filter-popup ul li:last-child {
  margin: 0;
}
.ho-body__body {
  background: #fff;
  border-top: 1px solid #f0f1f1;
  padding: 34px 20px 40px 64px;
}
.ho-body__body-header {
  margin-bottom: 17px;
  font: 700 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-information__filter-popup {
  z-index: 30;
  position: absolute;
  top: 37px;
  right: -5px;
  background: #fff;
  padding: 32px;
  border-radius: 8px;
  border: solid 1px #ebebeb;
  box-shadow: 0 12px 24px 0 rgba(45, 73, 88, 0.15);
  text-align: left;
}
.ho-information__filter-popup ul {
  padding: 0;
}
.ho-information__filter-popup ul li {
  display: block;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: rgba(38, 38, 38, 0.55);
  cursor: pointer;
}
.ho-information__filter-popup ul li a {
  color: rgba(38, 38, 38, 0.55);
  text-decoration: none;
}
.ho-information__filter-popup ul li a:hover {
  color: rgba(38, 38, 38, 0.8);
}
.ho-information__filter-popup ul li.active {
  color: #262626;
  cursor: default;
}
.ho-information__filter-popup ul li:last-child {
  margin: 0;
}
.ho-btn-setting__footer {
  border-top: 2px solid #ebebeb;
  padding: 27px 32px 0;
  margin: 21px -32px 0;
}
.ho-btn-setting__footer a {
  color: #262626;
  text-decoration: none;
}
.location-map {
  width: 100%;
  height: 320px;
  overflow: hidden;
  border-radius: 8px;
}
.ymap-container {
  width: 100%;
  height: 100%;
}
.modal-popup .modal-body {
  padding: 0;
}
.modal-popup .modal-dialog-centered {
  width: 928px;
  max-width: 95%;
}
.modal-popup .close {
  font-size: 14px;
  color: #000000;
  opacity: 1;
  text-shadow: none;
  margin: 0;
  padding: 0;
}
.modal-popup .close span {
  font-size: 21px;
  position: relative;
  top: 2px;
  margin-right: 5px;
}
.modal-popup .modal-header {
  border: 0;
  padding: 0 0 16px;
}
.modal-popup .modal-content {
  background: none;
  border: 0;
}
.ho-form {
  max-width: 934px;
}
.ho-form__check {
  display: inline-block;
  vertical-align: top;
  padding: 4px 5px 0 0;
  width: 67px;
}
.ho-form__item {
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 48px;
  padding-bottom: 21px;
}
.ho-form__item--last {
  margin: 0;
  padding-bottom: 0;
  border: 0;
}
.ho-form__item--staff {
  padding-bottom: 40px;
}
.ho-form__item .ho-body__grid {
  margin-right: -15px;
  margin-left: -15px;
  max-width: none;
  width: auto;
}
.ho-form__item label {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
  color: rgba(38, 38, 38, 0.55);
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
}
.ho-form__item .form-group {
  margin-bottom: 32px;
}
.ho-form__item-head {
  margin-bottom: 24px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-form__item-body {
  font: 400 14px/1.43 'Roboto', sans-serif;
}
.ho-form__footer {
  margin: 0;
  padding: 48px 0 0;
}
.ho-form__footer .btn {
  margin-right: 20px;
}
.custom-select {
  height: 56px;
  border: solid 1px #d6d6d6 !important;
  box-shadow: none !important;
  font: 600 16px 'Open Sans', sans-serif;
}
.form-control {
  height: 56px;
  border: solid 1px #d6d6d6 !important;
  box-shadow: none !important;
  color: #000000;
  font: 600 16px 'Open Sans', sans-serif;
}
.form-control::-webkit-input-placeholder,
.form-control::-moz-placeholder,
.form-control:-ms-input-placeholder,
.form-control:-moz-placeholder,
.form-control::placeholder {
  color: #000 !important;
  opacity: 1 !important;
}
.form-control:focus,
.custom-select:focus {
  border: solid 1px #000000 !important;
}
.form-control.is-valid,
.custom-select.is-valid {
}
.form-control.is-invalid,
.custom-select.is-invalid {
  border: solid 1px #d43836 !important;
}
textarea.form-control {
  padding-top: 16px;
  padding-bottom: 15px;
  line-height: 1.5;
}
.ho-form__hours {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.ho-form__hours-border {
  padding: 0 15px;
  font: 600 16px 'Open Sans', sans-serif;
  letter-spacing: -0.3px;
  color: #262626;
}
.ho-form__locations {
  height: 320px;
  border-radius: 8px;
}
.custom-control {
  font: 600 16px 'Open Sans', sans-serif;
  color: #262626;
  padding-left: 30px;
}
.custom-control label {
  text-shadow: none;
  font: 400 16px 'Roboto', sans-serif;
  color: #262626;
  cursor: pointer;
}
.custom-control label::after {
  width: 22px;
  height: 22px;
  left: -30px;
  margin-top: -7px;
  box-shadow: none !important;
}
.custom-control label::before {
  width: 22px;
  height: 22px;
  left: -30px;
  margin-top: -7px;
  border: solid 1px #d6d6d6 !important;
  box-shadow: none !important;
  cursor: pointer;
}
.ho-form__hours-select {
  width: 48%;
}
.ho-form__nolabel {
  padding-top: 45px;
}
.ho .ho-tooltip {
  position: relative;
  top: 2px;
  border: 0;
  padding: 0;
  width: 16px;
  height: 16px;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  background-color: #848585;
  border-radius: 50%;
  font: 700 10px/1.6 'Roboto';
  letter-spacing: -0.21px;
  text-align: center;
  color: #ffffff;
  vertical-align: top;
}
.ho-form__select-multiple .form-control {
  border: 0 !important;
  padding: 0 !important;
  background: none;
}
.ho-form__select-input {
  margin-top: 12px;
}
.ho-form__select-input li {
  display: block;
  font-size: 16px;
  line-height: 1.5em;
  margin-top: 1em;
}
.ho-form__select-input li span {
  font-size: 16px;
  line-height: 2em;
  background: none;
  color: #262626;
  padding: 0;
}
.ho-form__select-input li button.b-form-tag-remove {
  margin-left: 24px;
  color: #174b93;
  opacity: 1;
}

.ho-autorize:before {
  display: none;
}
.ho-autorize {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 80px 0 62px;
}
.ho-autorize__logo {
  margin-bottom: 36px;
  font-family: SFProDisplay;
  font-size: 36px;
  font-weight: 300;
  line-height: 1.67;
  color: #000;
}
.ho-autorize__logo strong {
  font-weight: 900;
  color: #174b93;
}
.ho-autorize__footer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  color: rgba(38, 38, 38, 0.55);
}
.ho-autorize__footer span {
  display: block;
  margin: 0 50px;
}
.ho-autorize__footer a {
  display: block;
  color: rgba(38, 38, 38, 0.55);
  margin: 0 50px;
  text-decoration: none;
}
.ho-autorize__footer a:hover {
  text-decoration: underline;
}
.ho-autorize__form {
  width: 280px;
  margin: 0 auto;
  padding-bottom: 20vh;
}
.ho-autorize__form .form-control {
  margin-bottom: 16px;
}
.ho-autorize__form .btn {
  width: 100%;
  text-align: center;
  margin-top: 16px;
}
.ho-autorize__form-check {
  text-align: center;
  margin-top: 24px;
}
.ho-autorize__form-check label {
  color: #262626 !important;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.ho-autorize__form-lnk {
  text-align: center;
  margin-top: 24px;
}
.ho-autorize__form-lnk a {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
  color: rgba(38, 38, 38, 0.55);
  text-decoration: none;
}
.ho-autorize__form-lnk a:hover {
  color: #000;
}
.ho-autorize__form-header {
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.3px;
  margin: 0 -30px 24px;
  color: #262626;
}
.ho-autorize__form-comment {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  min-height: 54px;
  line-height: 1.13;
  letter-spacing: 0.2px;
  text-align: center;
  margin-bottom: 48px;
  color: #000000;
}
.ho-autorize__final {
  width: 280px;
  margin: 0 auto;
  padding-bottom: 20vh;
  height: calc(294px + 20vh);
}
.ho-autorize__final-header {
  padding: 45px 0 80px;
  position: relative;
  font: 700 24px/1 'Roboto', sans-serif;
  letter-spacing: 0.3px;
  text-align: center;
  color: #262626;
}
.ho-autorize__final-header:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 28px;
  height: 21px;
  background: url(assets/img/ico-check.svg) 0 0 no-repeat;
}
.ho-autorize__final-btn a {
  width: 100%;
}
.alert-wr {
  position: fixed;
  z-index: 80;
  top: 24px;
  left: 0;
  right: 0;
  text-align: center;
}
.alert {
  display: inline-block;
  vertical-align: top;
}
.alert .close {
  display: none;
}
.alert-danger {
  background: #d43836;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 5px 15px -10px #3b4596;
  color: #fff;
  font: 500 14px/1.29 'Roboto', sans-serif;
  padding: 16px 45px;
  text-align: center;
  color: #ffffff;
}
.form-group textarea {
  background-position: top calc(0.375em + 0.1875rem) right calc(1.375em + 0.1875rem) !important;
}
.multiselect__tags {
  height: 56px;
  border: solid 1px #d6d6d6 !important;
  box-shadow: none !important;
  font: 600 16px 'Open Sans', sans-serif;
}
.ho-staff-item__ava {
  background-color: #d8d8d8;
  background-image: url(assets/img/ava.png);
}
.ho-information__filter-name.default {
  cursor: default !important;
}
.files-add {
  margin-bottom: -16px;
}
.files-add input[type="file"]{
  position: absolute;
  left: -9999em;
}
.files-add__item {
  display: inline-block;
  vertical-align: top;
  margin: 0 16px 16px 0;
  width: 160px;
  height: 168px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}
.files-add__item-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 168px;
  background-size: cover;
  background-repeat: no-repeat;
}
.files-add__item-remove {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  width: 73px;
  height: 73px;
  background: url(assets/img/ico-remove.svg) 0 0 no-repeat;
  transition: all 0.1s linear;
}
.files-add__item-remove:hover {
  transform: scale(1.1);
}
.files-add__item-remove:before {
  content: ' ';
  position: absolute;
  top: 10px;
  right: 11px;
  width: 52px;
  height: 53px;
  background: url(assets/img/ico-remove-x.svg) 0 0 no-repeat;
}
.files-add__btn {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 160px;
  height: 168px;
  border: dashed 1px #adadad;
  border-radius: 8px;
  text-align: center;
  padding: 0 16px;
  margin: 0 16px 16px 0;
  font: 700 14px/1.43 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  text-align: center;
  color: #262626;
  cursor: pointer;
}
.files-add__btn:hover i {
  transform: scale(1.1);
}
.files-add__btn i {
  display: block;
  margin: 32px 0 10px;
  transition: all 0.1s linear;
}
.files-add__sort {
  margin-top: 32px;
}
.multi-select {
  color: #495057;
  font: 600 16px 'Open Sans', sans-serif;
  position: relative;
}
.multi-select__header {
  height: 56px;
  line-height: 54px;
  border: solid 1px #d6d6d6;
  border-radius: 4px;
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
  padding: 0 50px 0 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  position: relative;
  z-index: 7;
}
.multi-select__header.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem);
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.multi-select__header.is-valid {
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.multi-select__body {
  position: absolute;
  z-index: 10;
  top: 100%;
  margin-top: -1px;
  left: 0;
  right: 0;
  padding: 20px 24px 20px 16px;
  border-radius: 4px;
  border: solid 1px #d6d6d6;
  background: #fff;
}
.multi-select__body span {
  display: block;
  margin: 0 0 20px;
  color: rgba(0, 0, 0, 0.5);
}
.multi-select__body span:last-child {
  margin: 0;
}
.multi-select__body span.active {
  color: rgba(0, 0, 0, 1);
}
.multi-select__body-scroll {
  max-height: 170px;
  overflow-y: auto;
  padding-top: 5px;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 150;
  background: rgba(0, 0, 0, .2) url(assets/img/loading.svg) center center no-repeat;
  background-size: auto 80px;
}
.ho-setting__tabs li {
  display: inline-block;
  vertical-align: top;
  margin-right: 64px;
}
.ho-setting__tabs li a {
  display: block;
  height: 40px;
  font: 400 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #5e6777;
  text-decoration: none;
}
.ho-setting__tabs li a:hover {
  border-bottom: 4px solid #174b93;
  color: #262626;
}
.ho-setting__tabs li a.active {
  border-bottom: 4px solid #174b93;
  font-weight: 700;
  color: #262626;
}
.ho-setting__tabs li:last-child {
  margin: 0;
}
.ho-setting {
  padding: 28px 0 0;
  max-width: 928px;
}
.ho-setting__user {
  display: table;
  width: 100%;
  margin-bottom: 57px;
}
.ho-setting__user-photo {
  display: table-cell;
  vertical-align: top;
  width: 120px;
  position: relative;
}
.ho-setting__user-photo__img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
}
.ho-setting__user-photo__img.default {
  background: url(assets/img/ava-profile.svg) center center no-repeat;
}
.ho-setting__user-photo__btn {
  position: absolute;
  right: -10px;
  bottom: -10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 5px 15px -10px rgba(0, 0, 0, 0.5);
  background: #ffffff url(assets/img/ico-phote.svg) center center no-repeat;
  transition: all 0.1s linear;
}
.ho-setting__user-photo__btn:hover {
  background-color:#ebebeb;
}
.ho-setting__user-info {
  display: table-cell;
  vertical-align: top;
  padding-left: 36px;
}
.ho-setting__user-info strong {
  display: block;
  font: 600 24px/0.75 'Roboto', sans-serif;
  letter-spacing: 0.34px;
  color: #000000;
  margin-bottom: 12px;
}
.ho-setting__user-info span {
  display: block;
  opacity: 0.5;
  font: 400 14px/1.29 'SFProDisplay', sans-serif;
  letter-spacing: 0.2px;
  color: #000000;
  margin-bottom: 24px;
}
.ho-setting__user-access {
  position: relative;
  padding-left: 26px;
  font: 700 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #5e6777;
}
.ho-setting__user-access:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 14px;
  height: 24px;
  background: url(assets/img/ico-access.svg) 0 0 no-repeat;
}
.ho-setting__detals-row {
  margin-bottom: 20px;
  display: table;
  width: 100%;
}
.ho-setting__detals-row strong {
  font-weight: 700;
}
.ho-setting__detals-head {
  display: table-cell;
  vertical-align: middle;
  font: 400 14px/1.3 'SFProDisplay', sans-serif;
  opacity: .5;
  letter-spacing: 0.2px;
  width: 100px;
}
.ho-setting__detals-body {
  display: table-cell;
  vertical-align: middle;
  font: 400 14px/1.3 'SFProDisplay', sans-serif;
}
.ho-setting__detals-body a {
  color: #5e6777;
  text-decoration: underline;
}
.ho-setting__detals-body a:hover {
  color: #174b93;
}
.ho-setting__table {
  width: 100%;
}
.ho-setting__table th {
  font: 400 14px/1.43 'Roboto', sans-serif;
  text-align: left;
  padding-bottom: 10px;
  color: rgba(38, 38, 38, 0.55);
}
.ho-setting__table td {
  border-top: 1px solid #ededed;
  font: 400 16px/1.5 'Roboto', sans-serif;
  vertical-align: top;
  padding: 32px 0;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-setting__table td strong {
  font-weight: 500;
}
.ho-setting__table tr:hover .ho-setting__btn-close {
  opacity: 1;
}
.ho-setting__th-1 {
  width: 160px;
}
.ho-setting__th-2 {
  width: 160px;
}
.ho-setting__th-4 {
  width: 200px;
}
.ho-setting__th-5 {
  width: 110px;
}
.ho-setting__btn-close {
  display: block;
  float: right;
  width: 12px;
  height: 12px;
  background: url(assets/img/ico-close.svg) 0 0 no-repeat;
  position: relative;
  top: 6px;
  opacity: 0;
}
.ho-setting__btn-close:hover {
  opacity: .7 !important;
}
.el-active {
  color: #174b93;
  font-weight: 600;
}
.ho-setting__new-password {
  max-width: 542px;
}
.ho-setting__comment {
  font: 400 14px/1.43 'Roboto', sans-serif;
}
.ho-setting__comment strong {
  font-weight: 700;
}
.ho-setting__btn {
  margin-top: 48px;
}
.ho-setting__notification .custom-control {
  margin-bottom: 16px;
  margin-top: 16px;
}
.ho-history__head {
  font: 700 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #262626;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
}
.ho-history__list {
  padding: 0 0 0 68px;
}
.ho-history__item {
  position: relative;
  border-bottom: 1px solid #ededed;
  padding: 29px 0 32px;
}
.ho-history__item:last-child {
  border: 0;
}
.ho-history__ico {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ff3574;
  position: absolute;
  top: 29px;
  left: -68px;
}
.ho-history__ico--1 {
  background:  #ff3574 url(assets/img/ico-1.svg) center center no-repeat;
}
.ho-history__ico--2 {
  background: #22272b url(assets/img/ico-2.svg) center center no-repeat;
}
.ho-history__ico--2 {
  background: #174b93 url(assets/img/ico-3.svg) center center no-repeat;
}
.ho-history {
  max-width: 928px;
}
.ho-history strong {
  font-weight: 700;
}
.ho-history__head {
  line-height: 1.5em;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-history__body {
  font: 400 14px/1.43 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: rgba(38, 38, 38, 0.55);
  margin-top: 26px;
}
.ho-history__body-name {
  font-weight: 700;
}
.ho-history__head-right {
  font: 700 16px/1.5 'Roboto', sans-serif;
  text-align: right;
}
.ho-history__body {
  justify-content: space-between;
  flex-direction: row;
  display: flex;
}
.ho-history__body-left {
}
.ho-history__body-right {
}
.ho-notification__day {
  font: 700 16px/1.5 'Roboto', sans-serif;
  margin-bottom: 6px;
}
.ho-notification__head {
  font: 400 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #262626;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
}
.ho-notification__item {
  position: relative;
  border-bottom: 1px solid #ededed;
  padding: 0 0 32px;
  margin: 0 0 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.ho-notification__item:last-child {
  border: 0;
}
.ho-notification {
  max-width: 928px;
  color: #262626;
}
.ho-notification strong {
  font-weight: 700;
}
.ho-notification__clock {
  margin-bottom: 9px;
  font: 700 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-notification__clock span {
  display: inline-block;
  vertical-align: top;
  margin-left: 6px;
  margin-top: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff3574;
}
.ho-notification__name {
  font: 700 20px/1.8 'Roboto', sans-serif;
  letter-spacing: 0.25px;
}
.ho-notification__info {
  font: 400 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
}
.ho-notification__right {
  white-space: nowrap;
  padding-left: 10px;
}
.ho-notification__next-page {
  margin-top: 20px;
}
.ho-notification__next-page a {
  display: block;
  text-align: center;
  background: #f3f5f6;
  padding: 29px 0 28px;
  color: #2d2d2d;
  font: 700 16px/1.13 'Roboto', sans-serif;
  text-decoration: none;
  transition: all 0.1s linear;
}
.ho-notification__next-page a:hover {
  background: #f8f8f8;
}
.ho-help__form {
  width: 640px;
  margin: 0 auto;
  padding-bottom: 20vh;
}
.ho-help__header {
  text-align: center;
  margin-bottom: 48px;
  font: 700 24px/1 'Roboto', sans-serif;
  letter-spacing: 0.3px;
  color: #262626;
}
/* corp */
.ho-profile-user {
  position: relative;
  padding-left: 88px;
  margin-top: 24px;
}
.ho-profile-user__ava {
  position: absolute;
  top: 0;
  left: 0;
  width: 64px;
  height: 64px;
  background-color: #ccc;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 50%;
}
.ho-profile-user__name {
  font: 700 24px/1 'Roboto', sans-serif;
  margin-bottom: 16px;
}
.ho-profile-user__txt {
  font: 400 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #262626;
  height: 49px;
}
.ho-employees-watch {
  padding: 0 15px;
  max-width: 928px;
}
.modal-ok .modal-dialog {
  max-width: 463px;
  font: 400 16px/1.5 'Roboto', sans-serif;
}
.modal-ok .modal-footer {
  display: none;
}
.modal-ok .modal-body {
  padding: 32px 48px;
}
.modal-ok--time .modal-body {
  padding: 32px 48px 32px 92px;
  position: relative;
}
.modal-ok--time .modal-body:before {
  content: ' ';
  position: absolute;
  top: 37px;
  left: 32px;
  width: 36px;
  height: 39px;
  background: url(assets/img/ico-clock-time-ok.svg) 0 0 no-repeat;
  background-size: contain;
}
.ho-body__head-setting {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: -18px;
}
.ho-body__head-search {
  width: 336px;
  padding-right: 32px;
  position: relative;
  display: inline-block;
  vertical-align: top;
}
.ho-body__head-search input {
  padding-right: 28px;
}
.ho-body__input-clean {
  position: absolute;
  top: 17px;
  right: 40px;
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
}
.ho-body__input-clean:before {
  content: ' ';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 1px;
  background: #000;
}
.ho-body__input-clean:after {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background: #000;
}
.ho-staff-i {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #ededed;
  padding: 32px 0;
  font: 400 16px/1.5 'Roboto', sans-serif;
  max-width: 928px;
}
.ho-staff-i:last-child {
  border: 0;
}
.ho-staff-i__info {
  width: 100%;
}
.ho-staff-i__clock {
  min-width: 280px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
}
.ho-staff-i__clock--btn {
  width: 80px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
}
.ho-staff-i__clock--btn a {
  text-decoration: underline;
  color: #174b93;
}
.ho-staff-i__clock--btn a:hover {
  text-decoration: none;
}
.ho-staff-i__clock-auto {
  margin-top: 24px;
}
.ho-staff-i .e-clock {
  padding-left: 32px;
  position: relative;
  white-space: nowrap;
  display: inline-block;
  vertical-align: top;
}
.ho-staff-i .e-clock:before {
  content: ' ';
  position: absolute;
  left: 0;
  top: -4px;
  width: 20px;
  height: 22px;
  background: url(assets/img/ico-clock-time.svg) 0 0 no-repeat;
  background-size: contain;
}
.ho-staff-i .e-clock--none:before {
  display: none;
}
.ico-clock {
  position: absolute;
  left: 0;
  top: -4px;
}
.ho-staff-i__btn {
  margin-top: 15px;
}
.ico-clock {
  content: ' ';
  display: block;
  width: 20px;
  height: 22px;
  background: url(assets/img/ico-clock-time.svg) 0 0 no-repeat;
  background-size: contain;
}
.ico-clock--none {
  opacity: 0 !important;
  left: -9999px !important;
}
.ho-staff-i__status {
  min-width: 235px;
  text-align: right;
}
.tooltip.b-tooltip {
  opacity: 1;
}
.tooltip-inner {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 12px 24px 0 rgba(45, 73, 88, 0.15);
  border: solid 1px #ebebeb;
  background-color: #ffffff;
  font: 400 14px/1.29 'Roboto', sans-serif;
  color: #262626;
  padding: 24px;
  text-align: left;
  max-width: 233px;
}
.tooltip-inner strong {
  display: block;
  margin-top: 12px;
  line-height: 1.43;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
  border-top-color: #fff;
  margin-top: -1px;
}
.ho-table-scroll {
  overflow-x: auto;
  max-width: 1010px;
  width: calc(100vw - 365px);
}
.ho-table {
  width: 100%;
  max-width: 928px;
  margin-top: 45px;
}
.ho-table--bookings {
  max-width: inherit;
  width: 1010px;
}
.ho-table th {
  text-align: left;
  padding: 0 18px 11px 18px;
  font: 700 14px/1.33 'Roboto', sans-serif;
  border-bottom: 1px solid #d8d8d8;
  border-left: 1px solid #d8d8d8;
  color: #5e6777;
}
.td-hedaer {
  color: #5e6777;
}
.ho-table th:first-child {
  border-left: 0;
  padding-left: 0;
}
.ho-table td {
  text-align: left;
  vertical-align: middle;
  padding: 7px 14px 7px 18px;
  font: 400 14px/1.33 'Roboto', sans-serif;
  border-bottom: 1px solid #d8d8d8;
  border-left: 1px solid #d8d8d8;
  color: #262626;
  letter-spacing: -0.01em;
}
.ho-table td:first-child {
  border-left: 0;
  padding-left: 0;
}
.ho-table td:last-child {
  padding-right: 0;
}
.ho-table .ho-table__data {
  color: #5e6777 !important;
  font-weight: 700;
}
.ho-table__lnk-price-td {
  padding-left: 0 !important;
  width: 190px;
}
.ho-table__lnk-price {
  width: 190px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  font-weight: 700;
}
.ho-table__lnk-price a {
  text-decoration: underline;
}
.ho-table__lnk-price a:hover {
  text-decoration: none;
}
.ho-table .td-center {
  text-align: center !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.ho-table .ho-table__size-14 {
  font-size: 12px;
}
.td-nowrap {
  white-space: nowrap;
}
.td-status {
}
.td-status span {
  display: inline-block;
  vertical-align: top;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 3px 8px 0 0;
}
.ho-table .td-date {
  color: #5e6777 !important;
  font-weight: 700;
}
.td-bg {
  background: #f2f8ee;
}
.ho-modal__head {
  margin: 0 0 24px;
  font: 700 21px/1.33 'Roboto', sans-serif;
}
.ho-modal__head span {
  font: 400 16px/1.5 'Roboto', sans-serif;
  display: block;
}
.ho-modal__body p {
  margin: 0 0 16px;
}
.ho-modal__adress {
  margin: 0 0 16px;
  font: 700 16px/1.5 'Roboto', sans-serif;
}
.ho-modal__border {
  margin: 32px 0;
  height: 1px;
  background-color: #d8d8d8;
}
.ho-modal__header {
  margin: 0 0 16px;
  font: 700 16px/1.5 'Roboto', sans-serif;
}
.ho-modal__map {
  height: 144px;
}
.ho-modal__about {
  font: 700 12px/1.33 'Roboto', sans-serif;
  letter-spacing: 0.15px;
  margin-top: 24px;
}
.ho-staff-new {
  padding: 48px 0 48px;
  background: #fff;
  position: relative;
}
.ho-staff-new:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: -9999px;
  bottom: 0;
  right: -9999px;
  background: #fff;
  z-index: -1;
}
.ho-staff-new__head {
  margin-bottom: 24px;
  font: 700 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  color: #262626;
}
.ho-staff-new__close {
  display: inline-block;
  vertical-align: top;
  width: 12px;
  height: 12px;
  background: url(assets/img/close.svg) 0 0 no-repeat;
  margin-top: 2px;
}

.ho-staff-new__close:hover {
  opacity: .8;
}
.ho-staff-new__list {
  padding-bottom: 20px;
}
.ho-staff-new__item {
  margin-bottom: 10px;
}
.ho-staff-new__file {
  display: inline-block;
  vertical-align: top;
  border: 1px solid #adadad;
  height: 48px;
  border-radius: 8px;
  padding: 0 24px;
}
.ho-staff-new__file-name {
  font: 400 16px/46px 'Roboto', sans-serif;
  display: inline-block;
  vertical-align: top;
}
.ho-staff-new__file-close {
  margin-left: 21px;
  margin-top: 16px;
  display: inline-block;
  vertical-align: top;
  width: 12px;
  height: 12px;
  background: url(assets/img/close.svg) 0 0 no-repeat;
}
.ho-staff-new__file-close:hover {
  opacity: .8;
}
.td-color-red {
  color: #e6909b !important;
}
.td-color-green {
  color: #8cba5a !important;
}
.ho-setting__company {
  margin-top: 37px;
  position: relative;
  z-index: 20;
}
.ho-setting__company-head {
  color: #fff;
  font: 700 14px/1.43 'Roboto', sans-serif;
}
.ho-setting__company-head a {
  color: #fff;
  display: block;
  padding-right: 24px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}
.ho-setting__company-head a:hover {
  color: rgba(255, 255, 255, 0.9);
}
.ho-setting__company-head a:hover:before {
  opacity: .9;
}
.ho-setting__company-head a:before {
  content: '';
  width: 24px;
  height: 24px;
  background: url(assets/img/arrow-white.svg) 0 0 no-repeat;
  position: absolute;
  top: 0;
  right: 0;
}
.ho-setting__company-head a.active:before {
  transform: rotate(180deg);
}
.ho-setting__company-money {
  color: #fff;
  font: 400 16px/1.43 'Roboto', sans-serif;
}
.ho-setting__company ul {
  position: absolute;
  top: 100%;
  left: -21px;
  margin-top: 11px;
  max-width: 600px;
  border-radius: 4px;
  box-shadow: 0 12px 24px 0 rgba(45, 73, 88, 0.15);
  border: solid 1px #ebebeb;
  background-color: #ffffff;
  padding: 12px 24px;
}
.ho-setting__company ul li {
  display: block;
  margin: 12px 0;
  font: 400 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.03em;
  white-space: nowrap;
}
.ho-setting__company ul li a {
  text-decoration: none;
  color: rgba(116, 103, 103, 0.55);
}
.ho-setting__company ul li a:hover {
  color: rgba(116, 103, 103, 0.9);
}
.ho-setting__company ul li.active a {
  color: #262626;
  cursor: default;
}
.ho-employees-watch__header {
  font: 700 16px/1.5 'Roboto', sans-serif;
  margin: 0 0 24px;
}
.ho-employees-watch__item {
  border-bottom: 1px solid #ececec;
  padding: 32px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font: 400 16px/1.5 'Roboto', sans-serif;
}
.ho-employees-watch__item form {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.ho-employees-watch__item:first-child {
  border: 0;
}
.ho-employees-watch__txt {
  width: 100%;
}
.ho-employees-watch__rest-time {
  padding-left: 50px;
  white-space: nowrap;
  min-width: 200px;
}
.ho-employees-watch__rest-time span {
  display: block;
  color: #262626;
  opacity: .5;
}
.ho-employees-watch__rest-time strong {
  display: block;
  position: relative;
}
.ho-employees-watch__rest-time .ico-clock {
  right: 100%;
  margin-right: 10px;
  left: auto;
  top: -1px;
  opacity: 1;
}
.ho-employees-watch__plus-time {
  padding-left: 25px;
}
.ho-employees-watch__plus-time input {
  width: 114px;
}
.ho-employees-watch__plus-add {
  padding-left: 15px;
  padding-top: 4px;
}
.modal-body .d-block {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
  color: rgba(38, 38, 38, 0.55);
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
}
.modal-body {
  padding: 32px;
}
.ho-modal__grid {
  margin-right: -15px;
  margin-left: -15px;
  max-width: none;
  width: auto;
}
.ho-modal__grid .form-group {
  margin-bottom: 32px;
}
.ho-modal__header {
  font: 700 16px/1.5 'Roboto', sans-serif;
  letter-spacing: 0.05em;
  color: #262626;
  margin-bottom: 20px;
}
.ho-modal__footer {
  margin: 0;
  text-align: right;
}
.ho-modal__footer .btn {
  margin-left: 20px;
}
.popup-modal {
  width: 364px;
  margin: 0 auto;
}
.popup-modal .modal-body {
  padding: 32px;
  text-align: center;
}
.popup-modal h3 {
  margin: 0 0 18px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.33;
  letter-spacing: 0.23px;
  color: #262626;
}
.popup-modal p {
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: #262626;
  margin-bottom: 38px;
}
.popup-modal .d-block {
  text-shadow: none;
}
.ml-6 {
  margin-left: 20px;
}
.autocomplete-wr {
  height: 0;
  position: relative;
  z-index: 20;
}
.autocomplete {
  position: absolute;
  top: 3px;
  left: 0;
  right: 0;
  width: 100%;
  background: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(45, 73, 88, 0.15);
  border: solid 1px #d6d6d6;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
}
.autocomplete li {
  display: block;
}
.autocomplete li a {
  display: block;
  padding: 8px 10px;
  text-decoration: none;
  color:#000000;
}
.autocomplete li a:hover {
  background: #174b93;
  color: #ffffff;
}
.form_disable .form-group,
.form_disable .custom-control {
  position: relative;
}
.form_disable .form-group:before,
.form_disable .custom-control:before {
  content: ' ';
  position: absolute;
  z-index: 999;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
}
.form_disable .files-add__btn,
.form_disable .files-add__sort,
.form_disable .files-add__item-remove,
.form_disable #add-photos-group:before {
  display: none;
}
.vue-lb-info {
  display: none;
}
.ho-body__filter-multicheck li {
  position: relative;
  padding-left: 35px;
  cursor: pointer !important;
}
.ho-body__filter-multicheck li:before {
  content: ' ';
  position: absolute;
  top: -1px;
  left: 0;
  display: block;
  margin-right: 8px;
  width: 23px;
  height: 23px;
  border: solid 1px #d6d6d6 !important;
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e") 5px 5px no-repeat;
  background-size: 50% 50%;
  border-radius: 4px;
}
.ho-body__filter-multicheck li.active:before {
  border-color: #007bff;
  background-color: #007bff;
}
.ho-body__filter-btn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font: 500 14px/1.3em 'Roboto', sans-serif;
  letter-spacing: 0.2px;
  margin-top: 18px;
}
.ho-body__filter-btn a {
  text-decoration: none;
}
.ho-body__filter-btn__reset {
  color: #5e6777;
}
.ho-body__filter-date-head {
  padding: 0 0 30px;
  display: table;
  width: 100%;
}
.ho-body__filter-date-head__inp {
  display: table-cell;
  width: 50%;
}
.ho-body__filter-date-head__border {
  display: table-cell;
  width: 50px;
  min-width: 50px;
  vertical-align: middle;
  letter-spacing: -0.3px;
  text-align: center;
  color: #9b9b9b;
  font: 600 16px 'Open Sans';
}
body .mx-calendar-header-label {
  font: 700 16px 'Roboto';
  color: #2d2d2d;
}
body .mx-calendar-header-label button {
  color: #2d2d2d;
}
body .mx-calendar-header, body .mx-time-header {
  margin-bottom: 0;
}
body .mx-calendar {
  padding: 0 !important;
  border: 0 !important;
}
body .mx-calendar+.mx-calendar {
  margin-left: 15px;
}
body .mx-datepicker-main {
  border: 0 !important;
}
body .mx-calendar-content .cell {
  font: 700 14px/36px 'Roboto';
}
body .mx-calendar-content .cell.active {
  position: relative;
  background: none !important;
}
body .mx-calendar-content .cell.in-range,
body .mx-calendar-content .cell.hover-in-range {
  background: #e7edf4;
  color: #262626;
}
body .mx-calendar-content .cell.active div {
  border-radius: 50%;
  background: #174b93;
  color: #fff;
  position: relative;
  z-index: 1;
}
body .mx-calendar-content .active:before {
  content: ' ';
  position: absolute;
  z-index: 0;
  right: 0;
  top: 0;
  bottom: 0;
  left: 50%;
  background: #e7edf4;
}
body .mx-calendar-content .in-range + .active:before {
  right: 50%;
  left: 0;
}
body .mx-calendar-content {
  height: 279px;
  position: relative;
}
body .mx-table-date .today {
  color: #2a90e9 !important;
}
body .mx-table-date th {
  color: rgba(38, 38, 38, 0.55);
  font: 400 14px/64px 'Roboto';
}
body .mx-calendar-content:before {
  content: ' ';
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  border-bottom: 1px solid #ebebeb;
}
body .mx-table-date th:nth-child(6),
body .mx-table-date th:nth-child(7) {
  color: #174b93;
}
body .mx-table.mx-table-month,
body .mx-table.mx-table-year {
  background: #fff;
  position: relative;
  z-index: 10;
}
body .mx-table.mx-table-month .active:before,
body .mx-table.mx-table-year .active:before {
  display: none;
}
body .mx-table.mx-table-month .active div,
body .mx-table.mx-table-year .active div {
  border-radius: 0;
}
body .mx-table.mx-table-month .cell:hover,
body .mx-table.mx-table-year .cell:hover {
  background: none;
}
body .mx-table.mx-table-month .cell:hover div,
body .mx-table.mx-table-year .cell:hover div {
  background: #e7edf4;
}
body .mx-calendar-content .cell:hover {
  background: #e7edf4;
  color: #262626;
}
.ho-body__filter-date-send {
  text-align: right;
  padding-top: 40px;
}
.ho-table {
  width: 100%;
  margin-top: 45px;
}
.ho-table--bookings {
  max-width: inherit;
  width: 1010px;
}
.ho-table__price {
  white-space: nowrap;
}
.ho-table__div-border {
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #d8d8d8;
}
.ho-table th {
  text-align: left;
  padding: 0 18px 11px 18px;
  font: 700 14px/1.33 'Roboto', sans-serif;
  border-bottom: 1px solid #d8d8d8;
  border-left: 1px solid #d8d8d8;
  color: #5e6777;
}
.td-hedaer {
  color: #5e6777;
}
.ho-table th:first-child {
  border-left: 0;
  padding-left: 0;
}
.ho-table td {
  text-align: left;
  vertical-align: middle;
  padding: 7px 14px 7px 18px;
  font: 400 14px/1.33 'Roboto', sans-serif;
  border-bottom: 1px solid #d8d8d8;
  border-left: 1px solid #d8d8d8;
  color: #262626;
  letter-spacing: -0.01em;
}
.ho-table td:first-child {
  border-left: 0;
  padding-left: 0;
}
.ho-table td:last-child {
  padding-right: 0;
}
.ho-table .ho-table__data {
  color: #5e6777 !important;
  font-weight: 700;
}
.ho-table .ho-table__el-border + .ho-table__el-border {
  border-top: 1px solid #d8d8d8;
  margin-top: 5px;
  padding-top: 5px;
}
.ho-table--bg td:first-child,
.ho-table--bg th:first-child {
  padding-left: 10px;
}
.ho-table--bg td:last-child {
  padding-right: 10px;
}
.ho-body__pagination {
  margin-top: 40px;
}
.ho-body__pagination li {
  display: inline-block;
  vertical-align: top;
  margin-right: 14px;
}
.ho-body__pagination li a {
  text-decoration: underline;
  color: #5e6777;
}
.ho-body__pagination li a:hover {
  text-decoration: none;
}
.td-center {
  text-align: center !important;
}
.span-nowrap {
  white-space: nowrap;
}
.ho-body__add {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue